import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const childListSelector = createSelector(
  (state: RootState) => state.child.childList,
  (childList) => childList,
);

export const selectedChildSelector = createSelector(
  [
    (state: RootState) => state.child.childId,
    (state: RootState) => state.child.childList,
  ],
  (childId, childList) => childList.find((v) => v.childId === childId),
);

export const modeSelector = createSelector(
  (state: RootState) => state.user,
  (user) => user.mode,
);

export const userSelector = createSelector(
  (state: RootState) => state.user,
  (user) => user.user,
);

export const isLoadingSelector = createSelector(
  (state: RootState) => state.ui.countAction,
  (countAction) => countAction > 0,
);
